module.exports = __webpack_public_path__ + "static/media/brain.4492d11e.svg";